export const THEME_COLORS = {
  yellow: '#FFBF00',
  lightYellow: '#fdeec0',
  lightYellow2: '#fad666',
  lightYellow3: '#FFF6DB',
  darkYellow: '#d5a102',
  gray: '#D9D9D9',
  darkGray: '#8a8787',
  darkGray2: '#636363',
  lightGray: '#f3f3f3',
  black: '#000',
  white: '#fff',
} as const;


export const PLAN_FEATURES = {
  ADVANCED_AVATARS: 'ADVANCED_AVATARS',
  CUSTOM_VARIABLES: 'CUSTOM_VARIABLES',
  MULTIPLE_GENERATION: 'MULTIPLE_GENERATION',
  ELEVEN_LABS: 'ELEVEN_LABS',
  ELEVEN_LABS_OWN_KEY: 'ELEVEN_LABS_OWN_KEY',
  GPT_SCRIPT_GENERATION: 'GPT_SCRIPT_GENERATION',
  CSV_UPLOAD: 'CSV_UPLOAD',
  VIDEO_DURATION_2: 'VIDEO_DURATION_2',
} as const;

export const PLANS = {
  STARTER: 'STARTER',
  PRO: 'PRO',
  FREE: 'FREE',
  CUSTOM: 'CUSTOM'
} as const;
